export const COLOR_LIST = ["#7AC555", "#760DDE", "#FFA500", "#76A5EA", "#E876EA"];
